import {
  ICreateCourseParams,
  IEditCourseParams,
  IEditCourseStatusParams,
} from '@type/audition/course.type';
import { IPagnationParams } from '@type/common';
import { AxiosInstance } from 'axios';

export interface ICourseTagParams extends IPagnationParams {
  keywords?: string[];
  applicable?: string;
  courseType?: string;
  education?: string;
  subject?: string;
}

export default (axios: AxiosInstance, course: string) => ({
  // attributes type
  /**
   * 新增課程
   */
  createCourse(data: ICreateCourseParams): any {
    return axios.post(`${course}/courses`, data);
  },
  /**
   * 取得課程列表
   */
  getCourseList(): any {
    return axios.get(`${course}/courses`);
  },
  /**
   * 編輯課程
   */
  editCourse(id: string, data: IEditCourseParams): any {
    return axios.patch(`${course}/courses/${id}`, data);
  },
  /**
   * 編輯課程狀態
   */
  editCourseStatus(id: string, data: IEditCourseStatusParams): any {
    return axios.patch(`${course}/courses/${id}/cancel`, data);
  },
  /**
   * 刪除課程
   */
  deleteCourse(id: string): any {
    return axios.delete(`${course}/courses/${id}`);
  },
  /**
   * 取得單筆課程
   */
  getCourse(id: string): any {
    return axios.get(`${course}/courses/${id}`);
  },
  /**
   * 下載上月報表
   */
  downloadReport(): any {
    return axios.get(`${course}/reports/download`, { responseType: 'blob' });
  },
  /**
   * bulk import courses
   */
  async uploadCourseExcel(file: File): Promise<any> {
    const form = new FormData();
    form.append('file', file);
    return axios.post(`${course}/courses/batchImportCourseExcel`, form, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
  },
});
